import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
export function Problem() {
  return <section className="w-full bg-ink-soft px-5 py-16 sm:px-8 sm:py-24" data-id="element-145" data-mp="2pf8teiccqprr">
      <div className="mx-auto max-w-4xl" data-id="element-146" data-mp="2pd4mrsn2jcns">
        <SectionLabel data-id="element-147" data-mp="2bgivx1lmeo2v">El problema que nadie nombra</SectionLabel>
        <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-white sm:text-5xl" data-id="element-148" data-mp="2gesn714854j7">
          ¿Cuántas veces más vas a intentar sola?
        </h2>
        <p className="mt-4 font-display text-lg font-semibold text-violeta-300" data-id="element-149" data-mp="21olf9fbuf3wr">
          No falta fuerza. Falta un sistema.
        </p>

        <div className="mt-10 rounded-3xl border border-violeta-600/30 bg-ink p-6 sm:p-8" data-id="element-150" data-mp="1sphve94uqkh7">
          <blockquote className="border-l-2 border-violeta-500 pl-5 font-display text-lg font-semibold leading-snug text-violeta-200 sm:text-xl" data-id="element-151" data-mp="1wqtdzupb65fw">
            “No es que no podás salir. Es que nadie te dio las herramientas correctas. Hasta ahora.”
          </blockquote>
          <p className="mt-5 pl-5 font-display text-sm font-bold text-white sm:text-base" data-id="element-152" data-mp="1npdbe94qj7m8">
            +500 mujeres en Argentina ya lo tienen.
          </p>
        </div>
      </div>
    </section>;
}